var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":"Statistics","subtitle":"For all the numbers"}}),_c('ApplicantStats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }